import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function uploadFile(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await axios.post(`${API}/upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function createLead(payload) {
  const { data } = await axios.post(`${API}/leads`, payload);
  return data;
}

export async function refineMap(text, language) {
  const { data } = await axios.post(`${API}/interpret`, { text, language });
  return data;
}

export async function assessCase(text, language) {
  const { data } = await axios.post(`${API}/assess`, { text, language });
  return data;
}

export async function createCase(payload) {
  const { data } = await axios.post(`${API}/cases`, payload);
  return data;
}
